import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
const authorListEndpoint = ApiEndpoints.autor.authorList;
const pressEditEndpoint = ApiEndpoints.adminPress.PressEdit;
const pressUpdateEndpoint = ApiEndpoints.adminPress.PressUpdate;
const userName = "Admin";

export default function EditPress() {
  const navigate = useNavigate();
  const [authors, setAuthors] = useState([]);
  const { press_id } = useParams();

  const [previews, setPreviews] = useState({ banner_image: null, thumbnail: null, });
  const [postData, setPostData] = useState({ author_name: "", title: "", author_id: "", thumbnail: "", alt_thumbnail: "", banner_image: null, alt_banner_image: "", slug: "", description: "", createdBy: userName, date: new Date(), });

  // State variables
  const [data, setData] = useState({
    press: {},
    // categories: [],
    authors: [],
    // tags: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${pressEditEndpoint}${press_id}`,);
        setData(response);
        setPostData(response.pressrelease);
        setPreviews((prev) => ({
          ...prev,
          banner_image: BaseUrl + response.pressrelease?.banner_image || prev.banner_image,
          thumbnail: BaseUrl + response.pressrelease?.thumbnail || prev.thumbnail,
        }));

      } catch (error) {
        console.error("Error fetching Press data:", error);
      }
    };
    const fetchAuthors = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        setAuthors(response?.authors || []);
      } catch (error) {
        console.error("Failed to fetch authors:", error);
        setAuthors([]);
      }
    };

    fetchAuthors();
    fetchData();
  }, [press_id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      let updatedValue = value;
      if (name === "date") {
        updatedValue = new Date(value).toISOString();
      }
      setPostData((prev) => ({
        ...prev,
        [name]: updatedValue,
      }));
    }
  };

  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {

      if (key === "slug" || key === "title" || key === "description" || key === "createdBy" || key === "date") {

        if ((value === "" || value === null)) {
          toast.error(`The field "${key}" is mandatory.`);
          return;
        }
      }
    }
    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append("pressrelease_id", press_id);
    try {
      const response = await ApiRequest("POST", pressUpdateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/press");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Press Management',
    user: 'Admin',
    innerpage: 'Press Management / Press / Edit Press'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.title} name="title" type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small> (add prefix "pressrelease-" in slug)</label>
                  </div>
                  <input onChange={handleChange} value={postData?.slug} name="slug" type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>category<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"category_id"} options={categories} placeholder="Select Category" />
                </div>
              </div> */}
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input value={postData?.date ? new Date(postData?.date).toISOString().split("T")[0] : ""} onChange={handleChange} name="date" type="date" className="form-control" />
                </div>
              </div>


              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Name<small>*</small></label>
                  </div>

                  <CustomSelect defaultValue={postData?.author_id} onChange={handleChange} name="author_id" options={authors} placeholder="Select Author Name" />


                </div>
              </div>



              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Author Des<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="designation"  className="form-control" placeholder="Designation" />
                </div>
              </div> */}

              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Tag Name<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name="tag1" options={tags} placeholder="Select Tag Name" />
                </div>
              </div> */}
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> First Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData?.description} onChange={(event, editor) => handleEditorChange("description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Quote <small>*</small></label>
                  </div>
               <input value={postData.quote} onChange={handleChange} name="quote" type="text" className="form-control" placeholder="Enter Quote" />
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Second Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.description2} onChange={(event, editor) => handleEditorChange("description2", editor.getData())}/>
                </div>
              </div>
            </div>
          </div> */}
          <div className="add-content-wrap">
            <div className="row">

              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Listing Image (444 × 332)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail"
                    // maxSize={550 * 1024}
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews?.thumbnail} />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Listing Image  Alt<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.alt_thumbnail} name="alt_thumbnail" className="form-control" placeholder="Alt Thumbnail" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label> Detail Banner Image (1608 × 660)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="banner_image"
                    // maxSize={100 * 1024} // 320KB
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews?.banner_image}
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Detail Banner Image  Alt<small>*</small></label>
                  </div>
                  <input onChange={handleChange} value={postData?.alt_banner_image} name="alt_banner_image" className="form-control" placeholder="alt_banner_image" />
                </div>
              </div>

            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
